import React from 'react'
import {connect} from 'react-redux'
import {Alert, Button, Card, Col, Divider, message, Row, Spin, Typography, Upload} from 'antd'

import '../../asset/less/NewPieces.css'
import {FileSyncOutlined, InboxOutlined, UploadOutlined} from '@ant-design/icons'
import Dragger from 'antd/es/upload/Dragger'
import Meta from 'antd/es/card/Meta'
import {uploadImage} from '../../api/amazonS3'
import FormButton from '../../component/base/FormButton'
import {postArtwork, postArtworkAdmin} from '../../api/artworks'
import {postArtworkConfig} from '../../api/artworkConfigs'
import HttpError from '../../component/base/HttpError'
import moment from 'moment'
import {is_admin_user} from "../../app/role";

const {Title} = Typography

@connect((state) => ({
    userId: state.user.info.id,
    artistId: state.user.info.artistId, // artist obj id
    email: state.user.info.email,
    role: state.user.info.role
}))
class BulkUploadImage extends React.Component {
    constructor(props) {
        super(props)
        this.expoFormRef = React.createRef()
        this.state = {
            loading: false,
            updateBtnEnabled: false,
            fileList: [],
            previewVisible: false,
            previewImage: '',
            previewTitle: '',
            artistId: this.props.artistId,
            role: this.props.role
        }
    }

    customRequest = (options) => {
        const {onError, onSuccess, file, onProgress} = options
        uploadImage(this.props.email, file, onSuccess, onError, onProgress)
    }

    componentDidMount() {
    }

    handlePreview(file) {
        const getBase64 = (file) =>
            new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)

                reader.onload = () => resolve(reader.result)

                reader.onerror = (error) => reject(error)
            })

        if (!file.url && !file.preview) {
            file.preview = getBase64(file.originFileObj)
        }

        this.setState({
            previewImage: file.url || file.preview,
            previewVisible: true,
            previewTitle: file.name || file.url.substring(file.url.lastIndexOf('/') + 1)
        })
    }

    confirmUpdate(ins, state, props) {
        let promiseResults = []
        ins.setState({
            loading: true
        })
        state.fileList.forEach((element, index) => {
            let artworkParam = {
                name: element.name,
                s3_url: element.response.s3_url,
                static_url: element.response.static_url,
                year: -1,
                file_size: 'string',
                used_type: '',
                copy_num: 1,
                label_str: '',
                medium_type_str: '',
                material_type_str: '',
                size_type_str: '',
                size_desc_str: '',
                sell_type_str: '',
                price_type_str: '',
                style_type_str: '',
                extra_info_str: '',
                artwork_pieces_str: '',
                color_info_str: '',
                content_info_str: '',
                notes_str: ''
            }
            const user_created_date = moment().format('YYYY-MM-DD')
            let artworkConfigParam = {
                is_visible_gallery: true,
                is_display_watermark: true,
                is_framed: false,
                frame_size_h: 0,
                frame_size_w: 0,
                frame_size_d: 0,
                frame_desc: '',
                user_created_date,
                inventory_quantity: 1,
                inventory_prints_quantity: 50,
                prints_markup_percentage: 20
            }
            if (!is_admin_user(this.props)) {
                promiseResults.push(
                    postArtwork(artworkParam)
                        .then(async (response) => {
                            await postArtworkConfig({
                                artwork: response.data.id,
                                ...artworkConfigParam
                            })
                        })
                        .catch((error) => {
                            HttpError(error)
                        })
                )
            } else {
                promiseResults.push(
                    postArtworkAdmin({artist: state.artistId, ...artworkParam})
                        .then(async (response) => {
                            await postArtworkConfig({
                                artwork: response.data.id,
                                ...artworkConfigParam
                            })
                        })
                        .catch((error) => {
                            HttpError(error)
                        })
                )
            }
        })
        Promise.all(promiseResults)
            .then((p) => {
                ins.setState({
                    loading: false
                })
                message.info('Successfully Upload.').then((v) => {
                })
            })
            .catch((e) => {
                HttpError(e)
            })
    }

    render() {
        function layoutByView(inst, props, state) {
            const items = []
            let idx = 0
            state.fileList.forEach((element, index) => {
                if (element.status === 'done') {
                    idx += 1
                }
                items.push(
                    <Col xs={12} sm={8} md={6} key={index}>
                        <Card
                            style={{
                                marginBottom: '20px'
                            }}
                            cover={<img src={element.response && element.response.static_url}/>}
                            loading={element.response === undefined}
                            actions={[]}
                        >
                            <Row justify='space-between' align='middle'>
                                <Meta title={<span style={{whiteSpace: 'pre-line'}}>{element.name}</span>}/>
                            </Row>
                        </Card>
                    </Col>
                )
            })
            let isUpdate = idx !== 0 && idx === state.fileList.length
            if (isUpdate !== state.updateBtnEnabled) {
                inst.setState({
                    updateBtnEnabled: isUpdate
                })
            }
            return (
                <Row justify='flex-start' gutter={{xs: 8, sm: 16, md: 24}} style={{marginTop: '16px'}}>
                    {items}
                </Row>
            )
        }

        function getUpdateButton(inst, state, props, func) {
            if (state.updateBtnEnabled) {
                return (
                    <Button
                        block
                        icon={<FileSyncOutlined/>}
                        type='primary'
                        size='large'
                        onClick={() => {
                            func(inst, state, props)
                        }}
                    >
                        Confirm Upload
                    </Button>
                )
            } else {
                return (
                    <Button
                        disabled
                        icon={<FileSyncOutlined/>}
                        block
                        type='primary'
                        size='large'
                        onClick={() => {
                            func(inst, state, props)
                        }}
                    >
                        Confirm Upload
                    </Button>
                )
            }
        }

        return (
            <Spin size='large' spinning={this.state.loading}>
                <Divider orientation='left'>Bulk Upload</Divider>

                <Dragger
                    multiple={true}
                    style={{marginTop: 12}}
                    listType='picture'
                    fileList={this.state.fileList}
                    onPreview={this.handlePreview}
                    customRequest={this.customRequest}
                    onChange={({fileList: newFileList}) => this.setState({fileList: newFileList})}
                >
                    <p className='ant-upload-drag-icon'>
                        <InboxOutlined/>
                    </p>
                    <p className='ant-upload-text'>Click or drag images to this area to upload</p>
                    <p className='ant-upload-hint'>or</p>
                    <br/>
                </Dragger>
                <Divider/>
                <Upload
                    fileList={this.state.fileList}
                    onPreview={this.handlePreview}
                    customRequest={this.customRequest}
                    onChange={({fileList: newFileList}) => this.setState({fileList: newFileList})}
                    directory
                >
                    <Button style={{marginTop: 12}} icon={<UploadOutlined/>}>
                        Upload folder from Directory
                    </Button>
                    <Alert message={'Put images in a folder and upload the folder.'} type='info'/>
                </Upload>
                <Divider/>
                <Row align='middle' gutter={{xs: 8, sm: 16, md: 24}} style={{marginTop: 12}}>
                    <Col>
                        <Title level={3} style={{marginBottom: 0}}>
                            Pieces ({this.state.fileList.length})
                        </Title>
                    </Col>
                </Row>
                {layoutByView(this, this.props, this.state)}
                <FormButton>
                    <Col span={12} offset={6}>
                        {getUpdateButton(this, this.state, this.props, this.confirmUpdate)}
                    </Col>
                </FormButton>
            </Spin>
        )
    }
}

export default BulkUploadImage
